export function randomHex(n) {
  // todo: make random
  return '0x' + '4'.repeat(n);
}
